import React from "react";

import { IconCompass } from "~/components/icon";

import { useNavigateFromLink } from "../../../components/react/link";
import { COMPONENT_PATH, VIEW_PATH } from "../../Routes";

import { GenericBreadcrumb } from "./GenericBreadcrumb";

export const SubviewBreadcrumb = React.memo(() => {
	const linkToDefaultSubviewMode = useNavigateFromLink([VIEW_PATH, COMPONENT_PATH], {
		params: (params) => ({ ...params, mode: undefined }),
	});

	return (
		<GenericBreadcrumb
			canBeSaved={false}
			icon={<IconCompass className="block" />}
			isDirty={false}
			name="Explore"
			to={linkToDefaultSubviewMode}
		/>
	);
});
